/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class Table
{
  constructor (path, config)
  {
    this.path = path;

    Object.assign(this, config);
  }


  key (cass)
  {
    return cass.id;
  }


  upcastData (data)
  {
    if (Array.isArray(data))
    {
      return data.map(cass => this.upcastCass(cass));
    }

    return this.upcastCass(data);
  }


  upcastCass (cass)
  {
    return (this.upcast ?? []).reduce((cass, upcast) => upcast(cass), cass);
  }


  getParent (application, args)
  {
    const parent = this.parent(application, args);

    if (parent?.entity === undefined)
    {
      return { entity: parent, logic: parent };
    }

    return parent;
  }


  upsert (application, { args, verb, data })
  {
    const { entity } = this.getParent(application, args);

    if (verb === 'replace-one')
    {
      this.load(entity, data);
    }

    if (verb === 'replace-all')
    {
      this.loadAll(entity, data);
    }
  }


  remove (application, { args, verb, data })
  {
    const { entity, logic } = this.getParent(application, args);

    if (entity === null)
    {
      return;
    }

    if (verb === 'remove-one')
    {
      this.unload(entity, data);
    }

    if (verb === 'replace-all')
    {
      this.unloadAll(entity, logic, data);
    }
  }


  loadAll (entity, collection)
  {
    for (const data of collection)
    {
      this.load(entity, data);
    }
  }


  unloadAll (entity, logic, collection)
  {
    for (const { cass } of this.values(logic))
    {
      if (!collection.some(other => this.key(other) === this.key(cass)))
      {
        this.unload(entity, cass);
      }
    }
  }


};
